module.exports = __webpack_public_path__ + "img/icon-3.8aeb7d6c.png";